import { faArrowDown, faChevronDown, faEllipsisV, faMoneyBill, faShare, faStar, faTimes } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const FavoriteIcon = () => <FontAwesomeIcon icon={faStar}/>
export const ShareIcon = () => <FontAwesomeIcon icon={faShare}/>
export const ExpandMoreIcon = () => <FontAwesomeIcon icon={faChevronDown}/>
export const MoreVertIcon = () => <FontAwesomeIcon icon={faEllipsisV}/>
export const MoneyIcon = () => <FontAwesomeIcon icon={faMoneyBill}/>
export const ArrowDownwardIcon = (props:any) => <FontAwesomeIcon {...props} icon={faArrowDown}/>
export const CloseIcon = (props:any) => <FontAwesomeIcon {...props} icon={faTimes}/>
